// extracted by mini-css-extract-plugin
export default {"subtitle":"style_subtitle__He9l4"};